<template>
    <div class="story-timer">
        <div v-for="(storyTimer, index) in storyStats" class="story-timer_timer-container" @click="jumpToStory(index + 1)">
            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                <div class="story-timer_restart-story" v-if="storyTimer.done && storyIndex - 1 === index" @click="restartStory">
                    <img src="@/assets/img/icons/restart_story.svg">
                    <p>Yeniden Başlat</p>
                </div>
            </transition>
            <div :class="'st-timer-'+ index">
                <div class="st-t-passed"
                     :class="{ 'done' : storyIndex - 1 === index }">
                     <span class="chapter-text">Bölüm {{index + 1}}</span>

                     <svg width="9" height="10" viewBox="0 0 9 10">
    <defs>
        <filter id="fxli67n14a">
            <feColorMatrix in="SourceGraphic" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"/>
        </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <g>
            <g>
                <g filter="url(#fxli67n14a)" transform="translate(-694 -791) translate(356 777) translate(185 1.5)">
                    <g>
                        <path fill="#000" fill-rule="nonzero" d="M0 8.67c.02.918.928 1.474 1.723 1.037l6.392-3.76c.348-.204.585-.579.585-1.02 0-.44-.237-.815-.585-1.02L1.723.153C.928-.284.02.266 0 1.185V8.67z" transform="translate(153 12.5)"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>


                     </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "StoryTimeline",
        data() {
            return {
                storyStats: [
                    {'done': false},
                    {'done': false},
                    {'done': false},
                    {'done': false}
                ]
            }
        },
        computed: {
            storyIndex() {
                return this.$store.state.storySequence;
            }
        },
        methods: {
            restartStory() {
                EventBus.$emit('restart-story');
            },
            jumpToStory(value) {
                this.$router.push({ name : "Story"+value});
            }
            /*
            changeStory(value) {
                this.$router.push('/0'+value);
            }
            */
        },
        watch: {
            storyIndex(value) {
                this.storyStart = [
                    {'done': false},
                    {'done': false},
                    {'done': false},
                    {'done': false}
                ]
            }
        },
        mounted() {
            EventBus.$on('story-done', (payload) => {
                this.storyStats[payload.story - 1].done = payload.value;
            });
        }
    }
</script>

<style lang="scss">
    .story-timer {
        display: flex;
        justify-content: center;
        align-items: center;
        height: auto;
        margin-bottom: 2vh;
        position: absolute;
        bottom: 0;
        z-index: 10;

        &_timer-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            min-height: 35px;
            max-height: 35px;
            justify-content: flex-end;
        }

        &_restart-story {
            display: flex;
            width: 100%;
            justify-content: space-evenly;
            margin-bottom: 10px;
            cursor: pointer;
            @media only screen and (max-device-width: 768px) {
                p {
                    display: none;
                }
                img {
                    width: 50px;
                    margin-bottom: 10px;
                    object-fit: contain;
                }
            }
        }

        div[class*='st-timer-'] {
            width: 172px;
            margin: 0 5px;
            color: white;
            align-items: center;
            display: flex;
            font-size: 12px;
            font-weight: bold;
            
            &:hover {
                cursor: pointer;
            }

            .st-t-passed {
                width: 100%;
                height: 100%;
                // background: white;
                background-color: rgba(0, 0, 0, 0.7);
                border-radius: 100px;
                padding: 10px 15px;
                margin: 0;
                display: flex;
                align-items: center;

                &.done {
                    width: 100%;
                    background-color: white;
                    color: black;
                }

                & > svg {
                    margin-left: auto;
                }
            }
        }

        .chapter-text {
            display: flex;
        }
    }

</style>
